module.exports = __webpack_public_path__ + "img/c833e93.png";